import $ from "jquery";

export const init = () => {
  $(".intro-header-section .contact-btn").on("click", (e) => {
    let id = $(e.target).parents(".contact-info").data('id');
    let $det = $("#" + id);
    $det.hasClass("open") ? $det.removeClass("open") : $det.addClass("open");
  });

  $(".intro-header-section .close-btn").on("click", (e) => {
    let id = $(e.target).parents(".contact-details").data('id');
     $("#" + id).removeClass("open");
  });
};
